<template>
  <div class="addtocart">
    <modal full-header @close="closeModal" id="GiftAddToCart" ref="addModal">
      <template slot="body">
        <div class="container-fluid pitem-details gift-cart" style="max-height:400px">
          <h3 class="pt-2">{{ product.Name }}</h3>
          <p v-html="product.ShortDescription"></p>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="From Name">{{ $t('message.fromName') }}</label>
              <input
                id="FromName"
                v-model="messageModel.From"
                name="fromName"
                type="text"
                @change="fixQuantity()"
                class="form-control"
              />
              <div
                class="invalid-feedback"
              >{{ OOErrors.first("fromName") | inputNameLocale("fromName") }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="ToField">{{ $t('message.toName') }}</label>
              <input
                id="ToField"
                v-model="messageModel.To"
                name="toName"
                type="text"
                @change="fixQuantity()"
                class="form-control"
              />
              <div
                class="invalid-feedback"
              >{{ OOErrors.first("toName") | inputNameLocale("toName") }}</div>
            </div>
            <div class="form-group col-md-6">
              <label for="Email">{{ $t('message.giftEmail')+"*" }}</label>
              <img
                id="giftHelpImage"
                v-bind:title="getToolTipMessage"
                class="toolTipIcon"
                :src="getToolTipIcon()"
                alt="toolTipIcon"
              />
              <input
                id="Email"
                v-validate="'required|email'"
                v-model="messageModel.Email"
                name="giftEmail"
                @change="fixQuantity()"
                type="text"
                class="form-control"
              />

              <div
                class="invalid-feedback"
              >{{ OOErrors.first("giftEmail") | inputNameLocale("giftEmail")}}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="Message">{{ $t('message.message') }}</label>
              <textarea
                id="Message"
                v-model="messageModel.Message"
                name="message"
                class="form-control"
              />
              <div
                class="invalid-feedback"
              >{{ OOErrors.first("message") | inputNameLocale("message")}}</div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="w-100 pb-4 pt-2 d-flex justify-content-center">
          <button
            :disabled="quantity <= 1"
            class="btn-white btn-circle d-flex justify-content-center align-items-center"
            @click="dec"
          >
            <span class="material-icons bigger-material-icons">remove_circle_outline</span>
          </button>
          <span class="px-4 d-flex align-items-center">
            <strong>{{ quantity }}</strong>
          </span>
          <button
            class="btn-white btn-circle d-flex justify-content-center align-items-center"
            @click="inc"
          >
            <span class="material-icons bigger-material-icons">add_circle_outline</span>
          </button>
        </div>
        <div class="w-100 d-flex justify-content-between mb-2">
          <button
            type="button"
            class="btn btn-lg btn-cancel"
            data-dismiss="modal"
          >{{ $t('message.cancel') }}</button>
          <button
            type="button"
            class="btn btn-lg btn-primary w-75 d-flex justify-content-between shadow"
            @click="addToCart()"
          >
            <span>{{ $t('message.addToCart') }}</span>
            <span>{{ totalPrice | formatMoney(currencySign) }}</span>
            <!-- <span v-else>{{ $t('message.maximumQuantityExceeded') }}</span> -->
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import modal from "../../modal";
import shared from "../../../sharedscripts/giftcard/details";
export default {
  name: "DetailsPopup",
  components: { modal },
  props: {
    product: {
      type: Object,
      default: () => {}
    },

    price: {
      type: Number,
      default: 0
    },
    productId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      quantity: 1,
      // maxItemQuantity: 20,
      options: {
        theme: "bootstrap4"
      },
      messageModel: {
        From: "",
        To: "",
        Message: "",
        Email: ""
      }
    };
  },
  computed: {
    ...shared.computed
  },
  methods: {
    ...shared.methods
  }
};
</script>
